import { render } from "./PDFItensNotaFiscal.vue?vue&type=template&id=4657d177&scoped=true"
import script from "./PDFItensNotaFiscal.vue?vue&type=script&lang=js"
export * from "./PDFItensNotaFiscal.vue?vue&type=script&lang=js"

import "./PDFItensNotaFiscal.vue?vue&type=style&index=0&id=4657d177&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.goncalves\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4657d177"]])

export default __exports__